<template>
  <div class="content">
    <list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <top :list="teacherList" />
    </list>
  </div>
</template>

<script>
/**
@description:老师排行
@createTime:2021-09-17
@create:wq
*/
import { List } from "vant";
import top from "./componentTop.vue";
export default {
  name: "",
  props: {},
  components: { List, top },
  data() {
    return {
      page: 1,
      teacherList: [],
      loading: false,
      finished: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    teacherRanking() {
      this.api.teacherRanking({ page: this.page }).then((res) => {
        this.teacherList = [...this.teacherList, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    onLoad() {
      this.teacherRanking();
      this.page++;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
}
</style>
